import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const renderNotification = (type, title, message) => {
  const content = (
    <div>
      <strong>{title}</strong>
      <div>{message}</div>
    </div>
  );

  switch (type) {
    case 'success':
      toast.success(content);
      break;
    case 'error':
      toast.error(content);
      break;
    case 'warning':
      toast.warn(content);
      break;
    case 'dismiss':
      toast.dismiss();
      break;
    case 'info':
    default:
      toast.info(content);
      break;
  }
};

export default renderNotification;